/**
 * @module modules/triage-menu-sk
 * @description <h2><code>triage-menu-sk</code></h2>
 *
 * Triage Menu provides functionality to triage anomalies in bulk. These are the provided features:
 * - New Bug: Creates a bug.
 * - Existing Bug: Adds anomalies to an existing bug.
 * - Ignore: Marks anomalies as Ignored
 *
 * @evt anomaly-changed Sent whenever an anomaly has been modified and needs to be re-rendered.
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    NudgeEntry: function() {
        return NudgeEntry;
    },
    TriageMenuSk: function() {
        return TriageMenuSk;
    }
});
const _lit = require("lit");
const _decorators = require("lit/decorators.js");
const _jsonOrThrow = require("../../../infra-sk/modules/jsonOrThrow");
const _errorMessage = require("../../../elements-sk/modules/errorMessage");
const _newbugdialogsk = require("../new-bug-dialog-sk/new-bug-dialog-sk");
const _existingbugdialogsk = require("../existing-bug-dialog-sk/existing-bug-dialog-sk");
const _telemetry = require("../telemetry/telemetry");
const _triageapi = require("../anomalies-table-sk/triage-api");
const _toastsk = require("../../../elements-sk/modules/toast-sk/toast-sk");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let NudgeEntry = class NudgeEntry {
    constructor(){
        // Whether the nudge entry should be marked as selected in UI.
        this.selected = false;
        // AnomalyData contains the anomaly and its x, y coordinates.
        // If nudge is succesful, we modify its x and y with NudgeEntry.x
        // and NudgeEntry.y
        this.anomaly_data = null;
        // start_revision to pass to backend to update DB value.
        this.start_revision = 0;
        // end_revision to pass to backend  to update DB value.
        this.end_revision = 0;
        // Number between -2 to 2 that indicates how many datapoints to nudge
        // an anomaly to.
        this.display_index = 0;
        // The specific commit position where the anomaly should be anchored.
        this.display_commit_number = 0;
        // x value to update AnomalyData if user clicks on this entry.
        this.x = 0;
        // y value to update AnomalyData if user clicks on this entry.
        this.y = 0;
    }
};
let TriageMenuSk = class TriageMenuSk extends _lit.LitElement {
    createRenderRoot() {
        return this;
    }
    render() {
        return (0, _lit.html)`<div>
      <new-bug-dialog-sk
        .anomalies=${this.anomalies}
        .traceNames=${this.traceNames}></new-bug-dialog-sk>
      <existing-bug-dialog-sk
        .anomalies=${this.anomalies}
        .traceNames=${this.traceNames}></existing-bug-dialog-sk>
      ${this.anomalies.length === 0 ? '' : this.generateNudgeButtons()}
      <div class="buttons">
        <button id="new-bug" ?disabled=${!this.buttonsEnabled} @click=${this.fileBug}>
          New Bug
        </button>
        <button
          id="existing-bug"
          ?disabled=${!this.buttonsEnabled}
          @click=${this.openExistingBugDialog}>
          Existing Bug
        </button>
        <button
          id="ignore"
          ?hidden=${this.anomalies.length === 0}
          ?disabled=${!this.buttonsEnabled}
          @click=${this.ignoreAnomaly}>
          Ignore
        </button>
      </div>
      <toast-sk id="ignore_toast" duration="8000">
        <div>
          <a> Anomaly has ignore with anomaly id: ${this.anomalies.map((a)=>a.id).join(', ')}</a>
        </div>
        <div class="close-bisect">
          <button
            id="hide-ignore-triage"
            class="action"
            type="button"
            @click=${()=>{
            var _this_ignoreTriageToast;
            return (_this_ignoreTriageToast = this.ignoreTriageToast) === null || _this_ignoreTriageToast === void 0 ? void 0 : _this_ignoreTriageToast.hide();
        }}>
            Close
          </button>
        </div>
      </toast-sk>
    </div>`;
    }
    fileBug() {
        _telemetry.telemetry.increaseCounter(_telemetry.CountMetric.TriageActionTaken, {
            action: 'file_bug'
        });
        this.newBugDialog.fileNewBug();
    }
    openExistingBugDialog() {
        _telemetry.telemetry.increaseCounter(_telemetry.CountMetric.TriageActionTaken, {
            action: 'associate_bug'
        });
        this.existingBugDialog.fetch_associated_bugs();
        this.existingBugDialog.open();
    }
    ignoreAnomaly() {
        _telemetry.telemetry.increaseCounter(_telemetry.CountMetric.TriageActionTaken, {
            action: 'ignore'
        });
        this.makeEditAnomalyRequest(this.anomalies, this.traceNames, 'IGNORE');
    }
    disableNudge() {
        this.allowNudge = false;
    }
    toggleButtons(enable) {
        this.buttonsEnabled = enable;
    }
    generateNudgeButtons() {
        if (this.allowNudge === false) {
            return (0, _lit.html)``;
        }
        if (this.nudgeList === null) {
            return (0, _lit.html)``;
        }
        return (0, _lit.html)`
      <div class="buttons">
        <span id="tooltip-key">Nudge</span>
        ${this.nudgeList.map((entry)=>(0, _lit.html)`
            <button
              value=${entry.display_index}
              class=${entry.selected ? 'selected' : ''}
              @click=${()=>this.nudgeAnomaly(entry)}
              ?disabled=${entry.selected}>
              ${entry.display_index > 0 ? '+' + entry.display_index : entry.display_index}
            </button>
          `)}
      </div>
    `;
    }
    nudgeAnomaly(entry) {
        this.makeNudgeRequest(this.anomalies, this.traceNames, entry);
    }
    /**
   * Sends request to /_/triage/edit_anomalies API to edit anomaly data.
   *
   * If edit action is IGNORE, the anomaly will be ignored.
   * If edit action is RESET, the bug will be deassociated with the existing bug id.
   * If edit action is NUDGE, the anomaly will be nudged with a new time range.
   *
   * @param anomalies - The anomalies to modify.
   * @param traceNames - Trace IDs for modified anomalies. This tells the API to
   * invalidate these traces from the cache.
   * @param editAction - An action that corresponds to different behaviors.
   */ makeEditAnomalyRequest(anomalies, traceNames, editAction) {
        (0, _triageapi.makeEditAnomalyRequest)(anomalies, traceNames, editAction).then(()=>{
            var _this_ignoreTriageToast;
            (_this_ignoreTriageToast = this.ignoreTriageToast) === null || _this_ignoreTriageToast === void 0 ? void 0 : _this_ignoreTriageToast.show();
            this.dispatchEvent(new CustomEvent('anomaly-changed', {
                bubbles: true,
                composed: true,
                detail: {
                    traceNames: traceNames,
                    editAction: editAction,
                    anomalies: anomalies
                }
            }));
        }).catch(()=>{
        // errorMessage is handled by makeEditRequest
        });
    }
    /**
   * Sends request to /_/triage/edit_anomalies API to nudge anomalies.
   *
   * @param anomalies - Anomalies to edit, should usally be just 1.
   * @param traceNames - Trace IDs for modified anomalies. This tells the API to
   * invalidate these traces from the cache.
   * @param entry - NudgeEntry that is being edited. We want to update its x and y
   * values, as well as its selected value.
   */ makeNudgeRequest(anomalies, traceNames, entry) {
        const keys = anomalies.map((a)=>a.id);
        const body = {
            keys: keys,
            trace_names: traceNames,
            action: 'NUDGE',
            start_revision: entry.start_revision,
            end_revision: entry.end_revision,
            display_commit_number: entry.display_commit_number
        };
        fetch('/_/triage/edit_anomalies', {
            method: 'POST',
            body: JSON.stringify(body),
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(_jsonOrThrow.jsonOrThrow).then((_)=>{
            var _entry_anomaly_data;
            for(let i = 0; i < anomalies.length; i++){
                anomalies[i].start_revision = entry.start_revision;
                anomalies[i].end_revision = entry.end_revision;
                anomalies[i].display_commit_number = entry.display_commit_number;
            }
            this.nudgeList.forEach((entry)=>{
                entry.selected = false;
            });
            entry.selected = true;
            entry.anomaly_data.x = entry.x;
            entry.anomaly_data.y = entry.y;
            this.dispatchEvent(new CustomEvent('anomaly-changed', {
                bubbles: true,
                composed: true,
                detail: {
                    traceNames: traceNames,
                    anomalies: [
                        (_entry_anomaly_data = entry.anomaly_data) === null || _entry_anomaly_data === void 0 ? void 0 : _entry_anomaly_data.anomaly
                    ],
                    displayIndex: entry.display_index
                }
            }));
        }).catch((msg)=>{
            (0, _errorMessage.errorMessage)(msg);
        });
    }
    setAnomalies(anomalies, traceNames, nudgeList) {
        this.anomalies = anomalies;
        this.traceNames = traceNames;
        this.nudgeList = nudgeList;
    }
    constructor(...args){
        super(...args);
        this.traceNames = [];
        this.anomalies = [];
        this.nudgeList = null;
        this.allowNudge = true;
        this.buttonsEnabled = true;
    }
};
_ts_decorate([
    (0, _decorators.property)({
        attribute: false
    }),
    _ts_metadata("design:type", Array)
], TriageMenuSk.prototype, "traceNames", void 0);
_ts_decorate([
    (0, _decorators.property)({
        attribute: false
    }),
    _ts_metadata("design:type", Array)
], TriageMenuSk.prototype, "anomalies", void 0);
_ts_decorate([
    (0, _decorators.property)({
        attribute: false
    }),
    _ts_metadata("design:type", Object)
], TriageMenuSk.prototype, "nudgeList", void 0);
_ts_decorate([
    (0, _decorators.property)({
        type: Boolean
    }),
    _ts_metadata("design:type", Boolean)
], TriageMenuSk.prototype, "allowNudge", void 0);
_ts_decorate([
    (0, _decorators.state)()
], TriageMenuSk.prototype, "buttonsEnabled", void 0);
_ts_decorate([
    (0, _decorators.query)('new-bug-dialog-sk'),
    _ts_metadata("design:type", typeof _newbugdialogsk.NewBugDialogSk === "undefined" ? Object : _newbugdialogsk.NewBugDialogSk)
], TriageMenuSk.prototype, "newBugDialog", void 0);
_ts_decorate([
    (0, _decorators.query)('existing-bug-dialog-sk'),
    _ts_metadata("design:type", typeof _existingbugdialogsk.ExistingBugDialogSk === "undefined" ? Object : _existingbugdialogsk.ExistingBugDialogSk)
], TriageMenuSk.prototype, "existingBugDialog", void 0);
_ts_decorate([
    (0, _decorators.query)('#ignore_toast'),
    _ts_metadata("design:type", typeof _toastsk.ToastSk === "undefined" ? Object : _toastsk.ToastSk)
], TriageMenuSk.prototype, "ignoreTriageToast", void 0);
TriageMenuSk = _ts_decorate([
    (0, _decorators.customElement)('triage-menu-sk')
], TriageMenuSk);
